module.exports = __webpack_public_path__ + "img/logo-chinese-express.275d17f.png";